import { parsePhoneNumber } from 'react-phone-number-input'

const E164_PATTERN = /^\+\d+$/

/**
 * Normalises a stored phone value to E.164 (`+31612345678`).
 * Legacy autosaved values may be display-formatted (`+31 6 12345678`); unparseable values yield `undefined`.
 */
export function toE164 (value: unknown): string | undefined {
  if (typeof value !== 'string' || value.trim() === '') {
    return undefined
  }
  if (E164_PATTERN.test(value)) {
    return value
  }
  return parsePhoneNumber(value)?.number
}
